import React from 'react';
import { Dialog, Transition } from '@headlessui/react';

// Base de los diálogos de reportar, bloquear y desbloquear. Headless UI ya
// atrapa el foco, lo devuelve al cerrar y pone role="dialog"/aria-modal.
// Con busy no se cierra con el fondo ni con Esc. afterLeave avisa cuando
// terminó de cerrarse, para abrir el siguiente (una sola ventana a la vez).
export default function SafetyDialog({ open, onClose, busy = false, afterLeave, children }) {
  return (
    <Transition.Root show={open} as={React.Fragment} afterLeave={afterLeave}>
      <Dialog as="div" className="relative z-confirm" onClose={() => !busy && onClose()}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
          <Transition.Child
            as={React.Fragment}
            enter="ease-out duration-200"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-150"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md bg-white dark:bg-gray-900 rounded-2xl shadow-xl p-5 text-gray-800 dark:text-gray-100">
              {children}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

// Ícono en un cuadrado de 48 px con fondo al 10 %, como en la app.
export function DialogIcon({ icon: Icon, tone = 'danger' }) {
  const cls = tone === 'danger' ? 'bg-red-500/10 text-red-500' : 'bg-rose-500/10 text-rose-500';
  return (
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${cls}`}>
      <Icon className="text-2xl" />
    </div>
  );
}

export function Spinner() {
  return <span className="inline-block w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />;
}

export const btnSecondary = 'flex-1 px-4 py-2.5 rounded-lg text-sm font-semibold bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 disabled:opacity-50';
export const btnDanger = 'flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-red-600 hover:bg-red-700 disabled:opacity-60';
export const btnBrand = 'flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold text-white bg-rose-500 hover:bg-rose-600 disabled:opacity-60';
export const row = 'w-full flex items-center gap-3 p-4 rounded-xl bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 text-left text-sm font-medium disabled:opacity-60';
